import { createContext } from 'react';

/** Consumed through the useToast hook, never directly. */
export const ToastContext = createContext(null);
